'use client';

import styled from 'styled-components';
import { COLORS } from '@/constants';

export const WidgetPreviewWrapper = styled.div`
  padding: 16px;
  min-height: 300px;
`;

export const PreviewLabel = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${COLORS['neutral/500']};
  text-transform: uppercase;
  letter-spacing: 0.07em;
  margin-bottom: 12px;
`;
